import { loanInfoConstants } from "../_constants";
import { history } from "../_helpers";
import {
    LoanInfoApi,
    LeadService,
    metadataService,
    ProfileApi,
    registrationService,
} from "../_services";
import { ServiceUtil } from "../_services/services.util";

export const loanInfoActions = {
    invalidateLoanState,
    viewAccount,
    togglePaymentSchedule,
    toggleAccountActivity,
    loadAccountViews,
    loadAccountActivity,
    clearAccountInfo,
    getNumberOfReferralsEarned,
    loadLeads,
    loadMostRecentLead,
};

function invalidateLoanState() {
    return (dispatch) => {
        dispatch(invalidate());
    };
    function invalidate() {
        return { type: loanInfoConstants.GET_USER_LOAN_VIEWS };
    }
}

function getNumberOfReferralsEarned() {
    return (dispatch) => {
        return LeadService.getNumberOfEarnedReferrals()
            .then((response) =>
                dispatch(getNumberOfReferralsEarnedSuccess(response.data))
            )
            .catch((error) => failure(error));
    };
    function getNumberOfReferralsEarnedSuccess(numReferrals) {
        return {
            type: loanInfoConstants.NUMBER_REFERRALS_EARNED_LOADED,
            numberOfReferralsEarned: numReferrals,
        };
    }
    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function clearAccountInfo() {
    return {
        type: loanInfoConstants.LOAD_USER_LOAN_VIEWS_SUCCESS,
        accountViews: [],
        accountViewsTimestamp: Date.now(),
    };
}

function loadAccountViews() {
    return (dispatch) => {
        return ServiceUtil.getAccountDashboard()
            .then((response) => {
                dispatch(loadAccountViewsSuccess(response.data));
            })
            .catch((error) => {
                failure(error);
            });
    };

    function loadAccountViewsSuccess(accountViews) {
        if (
            accountViews &&
            accountViews.loanAccountViews &&
            accountViews.loanAccountViews.length > 0
        ) {
            const [loan] = accountViews.loanAccountViews;
            ServiceUtil.setLocalBranchId(loan.sunLoanBranchId); // SET THE BRANCH FROM AN ACTIVE LOAN
        } else if (
            accountViews &&
            accountViews.leadRequests &&
            accountViews.leadRequests.length > 0
        ) {
            // SET THE BRANCH FROM A PREVIOUS LEAD (LAST ONE)
            const leadRequests = [...accountViews.leadRequests].sort(
                (a, b) => b.timestamp - a.timestamp
            );
            ServiceUtil.setLocalBranchId(leadRequests[0].branchId);
        }
        return {
            type: loanInfoConstants.LOAD_USER_LOAN_VIEWS_SUCCESS,
            accountViews: accountViews,
            accountViewsTimestamp: Date.now(),
        };
    }

    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function loadLeads() {
    return (dispatch) => {
        return LeadService.getRecentRequests()
            .then((response) => dispatch(loadLeadsSuccess(response.data)))
            .catch((error) => failure(error));
    };
    function loadLeadsSuccess(leads) {
        return { type: loanInfoConstants.LEADS_LOADED, leads: leads };
    }
    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function loadMostRecentLead() {
    return (dispatch) => {
        return LeadService.getMostRecentLead()
            .then((response) => dispatch(loadMostRecentLeadSuccess(response.data)))
            .catch((error) => failure(error));
    };
    function loadMostRecentLeadSuccess(lead) {
        return { type: loanInfoConstants.LAST_LEAD_LOADED, lastLead: lead };
    }
    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function loadAccountActivity(loanAccountView) {
    return (dispatch) => {
        return LoanInfoApi.getUserLoanActivity(loanAccountView.currentLoanId)
            .then((response) => dispatch(loadAccountActivitySuccess(response.data)))
            .catch((error) => failure(error));
    };
    function loadAccountActivitySuccess(accountActivity) {
        loanAccountView.accountActivity = accountActivity.accountHistory;
        loanAccountView.scheduledPayments = accountActivity.scheduledPayments;
        loanAccountView.detailsLoaded = true;
        loanAccountView.activityTimestamp = Date.now();
        return {
            type: loanInfoConstants.LOAD_ACCOUNT_ACTIVITY_SUCCESS,
            loanView: loanAccountView,
        };
    }
    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function viewAccount() {
    return (dispatch) => {
        try {
            dispatch(request());
            //history.push("/GetStarted");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request() {
        return { type: loanInfoConstants.GET_USER_LOAN_VIEWS };
    }

    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}
function togglePaymentSchedule(loanView) {
    return (dispatch) => {
        try {
            loanView.showPaymentSchedule = !loanView.showPaymentSchedule;
            dispatch(toggleView(loanView));
            //history.push("/NewLoanApp");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function toggleView(loanView) {
        return {
            type: loanInfoConstants.TOGGLE_PAYMENT_SCHEDULED_VIEW,
            loanView: loanView,
        };
    }

    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}
function toggleAccountActivity(loanView) {
    return (dispatch) => {
        try {
            loanView.showAccountActivity = !loanView.showAccountActivity;
            dispatch(toggleView(loanView));
            //history.push("/NewLoanApp");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function toggleView(loanView) {
        return { type: loanInfoConstants.TOGGLE_ACTIVITY_VIEW, loanView: loanView };
    }

    function failure(errorString) {
        return { type: loanInfoConstants.GENERIC_FAILURE, errorString };
    }
}